import { createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-01688e37")

_pushScopeId("data-v-01688e37")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("ジャーナル分析")
const _hoisted_2 = { class: "w-10/12 mx-auto" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createVNode("h2", { class: "font-bold text-gray-900 text-lg mb-4" }, "分析結果", -1)
const _hoisted_6 = {
  key: 0,
  class: "w-full text-center bg-gray-100 py-2 px-2 rounded-md"
}
const _hoisted_7 = { class: "flex gap-4" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Markdown = _resolveComponent("Markdown")
  const _component_m_button = _resolveComponent("m-button")
  const _component_MBaseModal = _resolveComponent("MBaseModal")

  return (_openBlock(), _createBlock(_component_MBaseModal, { onClose: _ctx.close }, {
    title: _withId(() => [
      _hoisted_1
    ]),
    body: _withId(() => [
      _createVNode("div", _hoisted_2, [
        (_ctx.initialLoading)
          ? (_openBlock(), _createBlock("p", _hoisted_3, "取得中..."))
          : (_openBlock(), _createBlock("div", _hoisted_4, [
              _hoisted_5,
              (!_ctx.analysisExists)
                ? (_openBlock(), _createBlock("p", _hoisted_6, " まだ分析結果がありません。 "))
                : (_openBlock(), _createBlock(_component_Markdown, {
                    key: 1,
                    class: "mb-4 whitespace-pre-wrap bg-gray-100 py-2 px-2 rounded-md",
                    source: _ctx.analysis!.data.analysis,
                    plugins: _ctx.plugins
                  }, null, 8, ["source", "plugins"]))
            ]))
      ])
    ]),
    footer: _withId(() => [
      _createVNode("div", _hoisted_7, [
        _createVNode(_component_m_button, {
          color: "primary-500",
          "hover-color": "primary-600",
          disabled: _ctx.initialLoading || _ctx.analysisGenerating,
          onClick: _ctx.getAiResponse
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.analysis ? "更新する" : "取得する"), 1)
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ])
    ]),
    _: 1
  }, 8, ["onClose"]))
})